// Input Component

import React from 'react'

import Input from '../input/input.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class InlineInput extends Input {
  render () {
    const { value, displayValue, canEdit, showInput, placeholder } = this.props
    const placeholderText = placeholder
      ? IntlUtil.convertMessage(placeholder)
      : ''

    return (
      <div
        className={`inline-input${
          !displayValue && !value ? ' hasnovalue' : ''
        }`}
      >
        {showInput ? (
          this._renderInput()
        ) : (
          <div
            onClick={canEdit ? this._onClickEdit : null}
            dangerouslySetInnerHTML={{
              __html: displayValue || value || placeholderText
            }}
          />
        )}
      </div>
    )
  }

  /* Private functions */
  _renderInput () {
    const {
      inputType,
      canEdit,
      displayValue,
      showInput,
      onRenderInput,
      onClickEdit,
      ...others
    } = this.props

    if (inputType === 'input') {
      return <Input {...others} autoFocus onBlur={this._onBlurInput} /> // eslint-disable-line react/jsx-handler-names
    } else if (inputType === 'textarea') {
      return <WysiwygEditor {...others} autoFocus onBlur={this._onBlurInput} /> // eslint-disable-line react/jsx-handler-names
    } else if (inputType === 'custom') {
      return onRenderInput ? onRenderInput() : null
    }

    return null
  }

  /* Event handlers */
  _onClickEdit = () => {
    if (this.props.onClickEdit) {
      this.props.onClickEdit()
    }
  }

  _onBlurInput = ev => {
    if (this.props.onBlur) {
      this.props.onBlur(ev)
    }
  }
}

export default InlineInput
